import { v4 as uuidv4 } from 'uuid';
import { DEFAULT_PAGE_SUCCESS } from 'store/modules/pages';

// ------------------------------------
// Constants
// ------------------------------------
export const READY = 'SSDC/APP/READY';
export const ROUTE_LOADED = 'SSDC/APP/ROUTE_LOADED';
export const ROUTE_UNLOADED = 'SSDC/APP/ROUTE_UNLOADED';
export const SET_TRACE_ID = 'SSDC/APP/SET_TRACE_ID';

export const SERVER_RENDER_ERROR = 'SSDC/APP/SERVER_RENDER_ERROR';
export const COMPONENT_RENDER_ERROR = 'SSDC/APP/COMPONENT_RENDER_ERROR';

// ------------------------------------
// Initial State
// ------------------------------------

export const initialState = {
	id: null,
	ready: false,
	ssag_host: '',
	baseUrl: '',
	trackingURL: null,
	trackingId: null,
	traceId: null,
	segmentWriteKey: null,
	googleMapsKey: null,
	environment: 'development',
	statusCode: 200,
	error: null,
	optimizelySdkKey: '',
	nearbyCities: [],
	nearbyFacilities: [],
	recaptchaSiteKey: '',
};

// ------------------------------------
// Reducer
// ------------------------------------
export default function reducer(state = initialState, action = {}) {
	switch (action.type) {
		case READY:
			return {
				...state,
				ready: true,
			};
		case SET_TRACE_ID:
			return {
				...state,
				traceId: uuidv4(),
			};
		case SERVER_RENDER_ERROR:
		case COMPONENT_RENDER_ERROR:
			return {
				...state,
				statusCode: 500,
				error: action.error,
			};
		case DEFAULT_PAGE_SUCCESS: {
			// Extract nearbyCities and nearbyFacilities from default page response
			const geolocatedFacilities = action.payload?.geolocatedFacilities;
			if (geolocatedFacilities) {
				return {
					...state,
					nearbyCities: geolocatedFacilities.nearbyCities || [],
					nearbyFacilities: geolocatedFacilities.nearbyFacilities
						? {
								facilityCollection: {
									collection:
										geolocatedFacilities.nearbyFacilities,
								},
							}
						: [],
				};
			}
			return state;
		}
		default:
			return state;
	}
}

// ------------------------------------
// Actions
// ------------------------------------
export function appReady() {
	return {
		type: READY,
	};
}

export function routeLoaded(location) {
	return {
		type: ROUTE_LOADED,
		payload: { location },
	};
}

export function routeUnloaded(location) {
	return {
		type: ROUTE_UNLOADED,
		payload: { location },
	};
}

export function serverRenderError(error) {
	return {
		type: SERVER_RENDER_ERROR,
		error,
	};
}

export function componentRenderError(error, stackTrace) {
	return (dispatch, getState) => {
		const {
			app: { environment },
		} = getState();
		return dispatch({
			type: COMPONENT_RENDER_ERROR,
			error: environment === 'development' ? stackTrace : error.message,
		});
	};
}

export function setTraceId() {
	return {
		type: SET_TRACE_ID,
	};
}

// ------------------------------------
// Selectors
// ------------------------------------
export function getTraceId(state) {
	return state.app.traceId || uuidv4();
}
